<template>
	<span>
		<span v-if="!emojiType">
			<vue-slider v-model="localValue" :class="{ 'slider-disabled': disabled}" :min="minValue" :max="maxValue" tooltip="none" @drag-end="!disabled && !avoidSaveOnChange ? showConfirmDialog = true : null" @click.native="!disabled && !avoidSaveOnChange ? showConfirmDialog = true : null" :dotStyle="dotStyle" :railStyle="railStyle" :disabled="disabled" :marks="marks">
				<template v-slot:label="{ value }">
					<div :class="['vue-slider-mark-label', { 'vue-slider-mark-label-last': value == maxValue }]">{{ marks[value].label }}</div>
				</template>
			</vue-slider>
			<base-dialog v-model="showConfirmDialog" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => { save() }" :cancelFn="() => { showConfirmDialog = false; localValue = initialValue }" :content="$t('confirm-save-slider')"></base-dialog>
		</span>
		<span v-else>
			<emoji-input v-model="localValue" @change="() => { save() }"/>
			<!-- Set min and max labels on both extremes of the emoji input component -->
			<span class="d-flex justify-content-between emoji-input-labels">
				<span>{{ minLabel }}</span>
				<span>{{ maxLabel }}</span>
			</span>
		</span>
	</span>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin'
import VueSlider from 'vue-slider-component'
import BaseDialog from '@/components/base/BaseDialog'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import { YELLOW_COLOUR, GRAY_COLOUR } from '@/constants/colours'
import { BORDER_RADIUS } from '@/constants/cssVariables'
import clinicHistoryVariableColorsMixin from '@/mixins/clinicHistoryVariableColors.mixin'
import EmojiInput from '@/components/base/forms/EmojiInput.vue'

const SAVE_EVENT = 'save'
const I18N_FILE = 'clinic-history'

export default {
  mixins: [clinicHistoryVariableColorsMixin, i18nMixin(I18N_FILE)],
  components: {
    VueSlider,
    'base-dialog': BaseDialog,
		EmojiInput
  },
  props: {
    value: [Number],
    name: [String],
    variableName: String,
    rawData: [Object],
    disabled: Boolean,
		showSliderLabel: {
			type: Boolean,
			required: false,
			default: true
		},
		minValue: {
			type: Number,
			required: false,
			default: 0
		},
		maxValue: {
			type: Number,
			required: false,
			default: 10
		},
		avoidSaveOnChange: Boolean,
		emojiType: {
			type: Boolean,
			required: false,
			default: false
		}
  },
  data () {
    return {
      showConfirmDialog: false,
      localValue: null,
      initialValue: null
    }
  },
  methods: {
    save () {
      let data = Object.assign({}, this.rawData)
      data.values = [this.localValue]
      ClinicHistoryRepository().saveVariableValue(data).then(() => {
        this.showConfirmDialog = false
        this.initialValue = this.localValue
				this.$emit(SAVE_EVENT, this.variableName, data.values)
      })
    }
  },
  computed: {
    getCurrentValueColor () {
			return this.getValueColor(this.localValue)
    },
		linearBackground () {
			return `linear-gradient(to right, ${this.minColor}, ${YELLOW_COLOUR}, ${this.maxColor})`
		},
		minLabel () {
			return this.$t(`clinic-history-variable-slider.${this.variableName}.min`)
		},
		maxLabel () {
			return this.$t(`clinic-history-variable-slider.${this.variableName}.max`)
		},
		marks () {
			return this.showSliderLabel ? {
				'0': {
					label: this.minLabel
				},
				'10': {
					label: this.maxLabel
				}
			} : null
		},
		dotStyle () {
			return {
				background: this.getCurrentValueColor,
				borderRadius: '50%',
				width: '1.5rem',
				height: '1.5rem',
				border: `1px solid ${GRAY_COLOUR}`
			}
		},
		railStyle () {
			return {
				background: this.linearBackground,
				height: '1rem',
				borderRadius: BORDER_RADIUS
			}
		}
	},
	created () {
		this.initialValue = this.value
		this.localValue = this.value
		this.$watch('value', value => {
			this.localValue = value
		})
		this.$watch('localValue', value => {
			this.$emit('input', value)
			this.$emit('change', value)
		})
	}
}
</script>

<style lang="scss">
	.vue-slider {
		padding: 0px !important;
		height: 1rem !important;
		margin-bottom: 2.5rem;
	}

	.vue-slider-dot {
		width: 1.5rem !important;
		height: 1.5rem !important;
		cursor: pointer;
	}

	@mixin sliderMarkLabel() {
		white-space: nowrap;
		border-radius: $border-radius;
		color: $gray;
		padding: .15rem .6rem;
		font-size: .65rem;
		@include mobile {
			font-size: .5rem;
		}
		border: 1px solid $gray;
		background-color: transparent;
	}

	.vue-slider-mark-label {
		left: 0 !important;
		transform: initial !important;
		@include sliderMarkLabel;
	}

	.vue-slider-mark-label-last {
		transform: translateX(-100%) !important;
		left: 0 !important;
	}

	.slider-disabled {
		filter: grayscale(1);
		.vue-slider-dot {
			cursor: initial;
		}
	}

	.emoji-input-labels {
		padding: 0 5.5rem;
		
		@include mobile {
			padding: 0 1rem;
		}

		span{
			@include sliderMarkLabel;
		}
	}


</style>


// WEBPACK FOOTER //
// src/components/shared/ClinicHistoryVariableSlider.vue